<template>
  <v-layout align-center column>
    <p class="Section-Title">Keuntungan Pendanaan di Dompet Kilat</p>
    <v-row v-if="!isMobile" justify="center">
      <v-col class="Transparant-Box">
        <v-skeleton-loader
          height="80"
          type="image"
          v-if="!isImgLoaded"
        ></v-skeleton-loader>
        <img
          src="../../assets/pendanaan/Cepat.png"
          srcset="
            ../../assets/pendanaan/Cepat@2x.png 2x,
            ../../assets/pendanaan/Cepat@3x.png 3x
          "
          @load="onImgLoad"
          class="Cepat"
        />
        <p class="Title">Cepat</p>
        <p class="Desc">Transaksi cepat, mudah dan tanpa biaya apapun.</p>
      </v-col>
      <v-col class="Transparant-Box">
        <v-skeleton-loader
          height="80"
          type="image"
          v-if="!isImgLoaded"
        ></v-skeleton-loader>
        <img
          src="../../assets/pendanaan/keuntungan.png"
          srcset="
            ../../assets/pendanaan/keuntungan@2x.png 2x,
            ../../assets/pendanaan/keuntungan@3x.png 3x
          "
          @load="onImgLoad"
          class="keuntungan"
        />
        <p class="Title">Keuntungan Menarik</p>
        <p class="Desc">
          Mendapatkan keuntungan menarik hingga 20% per tahun.
        </p>
      </v-col>
      <v-col class="Transparant-Box">
        <v-skeleton-loader
          height="80"
          type="image"
          v-if="!isImgLoaded"
        ></v-skeleton-loader>
        <img
          src="../../assets/pendanaan/sosial.png"
          srcset="
            ../../assets/pendanaan/sosial@2x.png 2x,
            ../../assets/pendanaan/sosial@3x.png 3x
          "
          @load="onImgLoad"
          class="sosial"
        />
        <p class="Title">Dampak Sosial</p>
        <p class="Desc Desc-sosial">
          Membantu pelaku UMKM mengembangkan usahanya.
        </p>
      </v-col>
    </v-row>

    <v-col v-if="isMobile" class="Transparant-Box-Mobile">
      <v-skeleton-loader
        height="80"
        type="image"
        v-if="!isImgLoaded"
      ></v-skeleton-loader>
      <img
        src="../../assets/pendanaan/Cepat.png"
        srcset="
          ../../assets/pendanaan/Cepat@2x.png 2x,
          ../../assets/pendanaan/Cepat@3x.png 3x
        "
        @load="onImgLoad"
        class="Cepat"
      />
      <p class="Title">Cepat</p>
      <p class="Desc">Transaksi cepat, mudah dan tanpa biaya apapun.</p>
    </v-col>
    <v-col v-if="isMobile" class="Transparant-Box-Mobile">
      <v-skeleton-loader
        height="80"
        type="image"
        v-if="!isImgLoaded"
      ></v-skeleton-loader>
      <img
        src="../../assets/pendanaan/keuntungan.png"
        srcset="
          ../../assets/pendanaan/keuntungan@2x.png 2x,
          ../../assets/pendanaan/keuntungan@3x.png 3x
        "
        @load="onImgLoad"
        class="keuntungan"
      />
      <p class="Title">Keuntungan Menarik</p>
      <p class="Desc">
        Mendapatkan keuntungan menarik hingga 20% per tahun.
      </p>
    </v-col>

    <v-col v-if="isMobile" class="Transparant-Box-Mobile">
      <v-skeleton-loader
        height="80"
        type="image"
        v-if="!isImgLoaded"
      ></v-skeleton-loader>
      <img
        src="../../assets/pendanaan/sosial.png"
        srcset="
          ../../assets/pendanaan/sosial@2x.png 2x,
          ../../assets/pendanaan/sosial@3x.png 3x
        "
        @load="onImgLoad"
        class="sosial"
      />
      <p class="Title">Dampak Sosial</p>
      <p class="Desc Desc-sosial">
        Membantu pelaku UMKM mengembangkan usahanya.
      </p>
    </v-col>
  </v-layout>
</template>
<script>
export default {
  data() {
    return {
      isMobile: false,
      isImgLoaded: false,
    };
  },

  created() {
    if (window.innerWidth >= 500) {
      this.isMobile = false;
    } else {
      this.isMobile = true;
    }
  },

  methods: {
    onImgLoad() {
      this.isImgLoaded = true;
    },
  },
};
</script>
<style scoped>
.Section-Title {
  width: 300px;
  height: 46px;
  flex-grow: 0;
  font-family: Sora;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.Title {
  width: 288px;
  height: 20px;
  flex-grow: 0;
  /* margin: 12px 114px 10px 120px; */
  font-family: Sora;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.Desc {
  width: 288px;
  height: 44px;
  flex-grow: 0;
  /* margin: 10px 0 0; */
  font-family: Inter;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}

.Cepat {
  width: 118px;
  /* height: 80px; */
  align-self: center;
  flex-grow: 0;
  margin: 0 82px 0px 82px;
  object-fit: contain;
}
.keuntungan {
  width: 118px;
  /* height: 80px; */
  align-self: center;
  flex-grow: 0;
  margin: 0 82px 0px 82px;
  object-fit: contain;
}
.Pelopor {
  width: 118px;
  /* height: 80px; */
  align-self: center;
  flex-grow: 0;
  margin: 0 82px 0px 82px;
  object-fit: contain;
}
.sosial {
  width: 118px;
  height: 118px;
  align-self: center;
  flex-grow: 0;
  margin: 0 82px 0px 82px;
  object-fit: contain;
}
.Transparant-Box {
  width: 285px;
  height: 166px;
  flex-grow: 0;
  margin: auto 10px auto 10px;
}

.Transparant-Box-Mobile {
  height: 166px;
  flex-grow: 0;
  margin: 20px 0 40px 10px;
}
</style>
